import { ROUTING_RULE_TYPES } from 'routing-ui/routing-rules/constants/RoutingTypes';
import { checkIsRoutingRulesType } from 'routing-ui/routing-rules/operators/routingRulesGetters';
import { buildRoutingRulesFromType } from 'routing-ui/routing-rules/utils/buildRoutingRules';
export const checkIsUnassigned = routingRuleDefinition => checkIsRoutingRulesType(routingRuleDefinition, ROUTING_RULE_TYPES.UNASSIGNED);
const getTeamIds = metadata => Array.isArray(metadata.teamIds) ? metadata.teamIds : undefined;
const getUserIds = metadata => Array.isArray(metadata.userIds) ? metadata.userIds.map(userId => parseInt(userId, 10)) : undefined;
export const getRoutingRules = metadata => {
  let {
    routingRuleDefinition
  } = metadata;
  if (!routingRuleDefinition) {
    routingRuleDefinition = buildRoutingRulesFromType(ROUTING_RULE_TYPES.USERS_AND_TEAMS, {
      teamIds: getTeamIds(metadata),
      userIds: getUserIds(metadata)
    });
  }
  return routingRuleDefinition;
};